define 'controller/GkProductPageController', ['jquery'], ($) ->
  class GkProductPageController

    constructor: (@$el) ->
      @$self = @$el
      @_init()

    _init: ->
      articlenumber = @$el.attr("data-article-number")
      $.ajax
        url: '/api/gk/view/product?articleNumber=' + articlenumber
        type: 'POST'
        xhrFields:
          showLoadingIndicator: false
        error : ->

